import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "nw-text-input",
  templateUrl: "./text-input.component.html",
  styleUrls: ["./text-input.component.css"],
})
export class TextInputComponent implements OnInit {
  @Input()
  text: string;

  @Input()
  create: (text: string) => void;

  @Input()
  cancel: () => void;

  constructor() {}

  ngOnInit(): void {}
}
